import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getQuoteData,
  getQuoteTemplate,
  getTemplateContent,
  createQuote,
  getEmailTemplate
} from "../../../ReduxStore/Slice/Quote/CreateQuoteSlice";
import { upload_contract_attachment } from "../../../Service/Contract/contractService";
import { clientDetailsUpdateApi } from "../../../ReduxStore/Slice/Contract/contractSlice";
import { getAllClient, getClientDetails } from "../../../Service/ThardPartyApi/ThardPartyAPI";
import Select from "react-select";
import { useDispatch } from "react-redux";
import ReusableModal from "../../../ExtraComponents/ReusableModal";
import Swal from "sweetalert2";
import {
  EMPTY_EMAIL_ERROR,
  EMPTY_SUBJECT_ERROR,
  EMPTY_SELECT_TEMPLET_ERROR,
  INVALID_EMAIL_ERROR,
  EMPTY_CC_EMAIL_ERROR,
  EMPTY_BCC_EMAIL_ERROR,
  INVALID_CC_EMAIL_ERROR,
  INVALID_BCC_EMAIL_ERROR,
  EMPTY_TEMPLET_BODY_ERROR

} from "../../../Utils/Common_Error";

import {
  ValidateEmail,
} from "../../../Utils/CommonFun";

import JoditEditor from 'jodit-react';
import * as Config from "../../../Utils/Config";
import axios from "axios";
import JSZip from "jszip";

const StepThree = ({
  formData1,
  handleChange,
  nextStep,
  prevStep,
  currentStep,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let QuoteId = sessionStorage.getItem("quote_id");
  const editor = useRef(null);

  if (location.state != undefined && location.state != null && location.state.record_id == undefined) {
    sessionStorage.setItem("quote_id", location.state.row.id);
    QuoteId = location.state.row.id;
  }

  let backupQuoteId = QuoteId;

  

  if (formData1 != undefined && formData1?.quoteid != undefined) {
    backupQuoteId = formData1?.quoteid;
  }

  if (location?.state != null && location?.state?.row?.id != undefined) {
    backupQuoteId = location.state.row.id;
  }



  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const userDetails = JSON.parse(localStorage.getItem("details"));
  const [quoteData, setQuoteData] = useState({});
  const [existingChargeBasis, setExistingChargeBasis] = useState([]);

  const [selectedPackage, setSelectedPackage] = useState("");
  const [allquotetemplate, setAllquotetemplate] = useState([]);


  const [isModalPackageEffected, setIsModalPackageEffected] = useState(false);
  const [prevButtonStatus, setPrevButtonStatus] = useState(false)


  const [allemailtemplate, setAllemailtemplate] = useState([]);
  const [content, setContent] = useState('');
  const [editorReady, setEditorReady] = useState(false);

  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [selectedAttachments, setSelectedAttachments] = useState([]);

  const [formData, setFormData] = useState({
    email_template_id: "",
    templateName: "",
    description: "",
    triggerEvent: "",
    subjectLine: "",
    bccEmail: "",
    replyTo: "",
    body: "",
    attachments: [],
  });

  const UpdateFormBody = useCallback((value) => {
    if (editor.current && editor.current.selection) {
      const imgTag = `<img src="${value}" width="252" height="160" style="display: inline-block; margin-left: 5px; vertical-align: middle;"/>`;
      editor.current.selection.insertHTML(imgTag);
    }
  }, []);


  const config1 = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
      buttons:
        "bold,italic,underline,strikethrough,ul,ol,paragraph,fontsize,font,brush,link,image,video,table,align,undo,redo,cut,copy,paste,selectall,source",
      removeButtons: ["speechRecognize"],
      toolbarSticky: false,

      style: {
        font: '14px "Poppins", Arial, sans-serif',
        color: "#000000",
      },

      controls: {
        font: {
          list: {
            Poppins: '"Poppins", sans-serif',
            Arial: "Arial, Helvetica, sans-serif",
            "Times New Roman": '"Times New Roman", Times, serif',
            Roboto: "Roboto, sans-serif",
            Verdana: "Verdana, Geneva, sans-serif",
          },
        },
      },

      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      defaultActionOnPaste: "insert_as_html",
      defaultActionOnPasteFromWord: "insert_as_html",
      pasteFromWord: { enable: true },

      uploader: {
        url: Config.base_url + "img/uploader",
        accept: "image/*,video/*",
        method: "POST",
        withCredentials: false,

        prepareData: async (formData1) => {
          const data = new FormData();
          formData1.forEach((file) => data.append("files[0]", file));

          try {
            const response = await axios.post(Config.base_url + "img/uploader", data, {
              headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.success && response.data.files?.length > 0) {
              UpdateFormBody(response.data.files[0]);
              return { success: true, files: response.data.files };
            }
            return { success: false, files: [] };

          } catch {
            return { success: false, files: [] };
          }
        },

        defaultHandlerSuccess: (response) => response?.files ?? [],
        defaultHandlerError: () => []
      },

      events: {
        afterInit: (editorInstance) => {
          setEditorReady(true);
          editor.current = editorInstance;
        }
      }
    }),
    [UpdateFormBody]
  );



  const [selectedTemplate, setSelectedTemplate] = useState({
    mail_to: "",
    cc_to: "",
    bcc_to: "",
    subject: "",
    template_id: "",
    template_body: "",
  });




  const [tempClientData, setTempClientData] = useState(null);
  const [clientid, setClientid] = useState("");
  const [error, setError] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [templatePreviewContent, setTemplatePreviewContent] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [hasPackage, setHasPackage] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [templatestatus, setTemplatestatus] = useState(false)

  const handleOpenModal = (templateId) => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  function cleanHtmlContent(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    const scripts = div.getElementsByTagName("script");
    const styles = div.getElementsByTagName("style");
    Array.from(scripts).forEach((script) => script.remove());
    Array.from(styles).forEach((style) => style.remove());
    const unorderedLists = div.querySelectorAll("ul");
    unorderedLists.forEach((list) => {
      list.style.listStyleType = "disc";
    });
    const orderedLists = div.querySelectorAll("ol");
    orderedLists.forEach((list) => {
      list.style.listStyleType = "decimal";
    });
    return div.innerHTML;
  }

  useEffect(() => {
    getQuote();
    getEmailTemplateFun();
    getQuoteAttachment();
  }, []);

  const ALLOWED_TYPES = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  };

  const extractZipAndSetAttachment = async (zipBlob) => {
    const zip = await JSZip.loadAsync(zipBlob);
    const attachments = [];

    for (const fileName of Object.keys(zip.files)) {
      const zipEntry = zip.files[fileName];

      // folder skip
      if (zipEntry.dir) continue;

      const ext = fileName.split(".").pop().toLowerCase();

      // sirf allowed files
      if (ALLOWED_TYPES[ext]) {
        const fileBlob = await zipEntry.async("blob");

        const file = new File([fileBlob], fileName, {
          type: ALLOWED_TYPES[ext], // 🔥 dynamic MIME type
          lastModified: Date.now(),
        });

        attachments.push(file);
      }
    }

    console.log("extracted attachments --", attachments);

    // EXACT file-input behaviour
    setFormData((prev) => ({
      ...prev,
      attachments,
    }));
  };

  const getQuoteAttachment = async () => {
    const req = { id: Number(QuoteId), agent_id: agent_id, ongoing_onoff: 1, type: "attachment" };
    const res = await axios.post(
      Config.base_url + "get_quote",
      req,
      {
        responseType: "blob",
        validateStatus: () => true,
      }
    );

    console.log("getQuoteAttachment res -- ", res.status)
    // const blob = await res.data;

    // console.log("getQuoteAttachment blob -- ", blob)
    if (res.data.type === "application/json") {
      const text = await res.data.text();
      const json = JSON.parse(text);

      console.warn(json.message);
      return;
    }

    // 🔥 Safe to unzip
    await extractZipAndSetAttachment(res.data);
    // await extractZipAndSetAttachment(blob);



  };

  const getEmailTemplateFun = async () => {
    const req = { agent_id: agent_id, template_trriger_id: 1 };
    await dispatch(getEmailTemplate(req))
      .unwrap()
      .then(async (res) => {

        // console.log("res -- getEmailTemplate ", res);
        if (res.status) {
          if (res.data.length > 0) {
            setFormData({
              ...formData,
              email_template_id: res.data[0].id,
              body: res.data[0].body,
            });
          }
          setAllemailtemplate(res.data);
        } else {
          setAllemailtemplate([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }


  // useEffect(() => {
  //   getQuoteTemplateFun();
  // }, [clientid]);

  const clientUpdateFunction = async () => {

    const req = { id: Number(QuoteId), agent_id: agent_id, check: "getData" };
    await dispatch(getQuoteData(req))
      .then(async (res) => {
        //console.log("res.quote client ", res.payload);
        if (res.payload.status) {
          // console.log("res.payload.quote client ", res);
          const agent_db = localStorage.getItem('agent_db');
          const token_crm = localStorage.getItem('authClientToken');
          const agent_url = localStorage.getItem('agent_url');
          const company_id = JSON.parse(localStorage.getItem("company_id"));
          const req = {
            agent_db: agent_db,
            company_id: company_id,
            pricing_tool_pratice_id: agent_id,
            module: res.payload.quote.Client.module_type,
            record_id: res.payload.quote.Client.record_id || 0,
          };
          await getClientDetails(req, agent_url, token_crm).then(async (res) => {
            if (res.IsSuccess) {
              const req = {
                agent_id: agent_id,
                ClientDetails: res.result
              };

              await dispatch(clientDetailsUpdateApi(req)).unwrap()
                .then((res) => {
                  if (res.status) {
                  } else {

                  }
                })
                .catch((err) => {
                  console.log("err", err);
                });


            }

          }).catch((err) => {
            console.log("err", err);
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const getQuote = async () => {
    setIsLoading(true);
    await clientUpdateFunction();
    const req = { id: Number(QuoteId), agent_id: agent_id };
    await dispatch(getQuoteData(req))
      .unwrap()
      .then(async (res) => {
        if (res.status) {
          // console.log("res -- getQuoteData ----  ", res?.quote?.is_effected);

          if (Number(res?.quote?.is_effected) === 1) {
            setPrevButtonStatus(true);
            setIsModalPackageEffected(true);
          }

          const chargeBasisIds = res?.quote?.QuotePackageServices?.flatMap(item =>
            item.Service?.ServiceChargeBases?.map(cb => cb.chargebasis_id) || []
          );

          // console.log("chargeBasisIds", chargeBasisIds);
          const matchingItems = res?.quote?.QuoteEnterDefaultValues.filter(item => chargeBasisIds.includes(item.chargebasis_id));
          // console.log("matchingItems", matchingItems);
          setExistingChargeBasis(matchingItems);
      
          // setSelectedTemplate({
          //   ...selectedTemplate,
          //   mail_to: res.quote.Client.email,
          // })
          setClientid(res.quote.client_id);
          setQuoteData(res.quote);
          setHasPackage(res.hasPackage);
          getQuoteTemplateFun(
            res.quote.Client.email,
            res.quote.client_id,
            res.quote.contact_owner
          );
          setIsLoading(false);
        } else {
          setClientid("");
          setQuoteData({});
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    // setIsLoading(false);
  };

  const getQuoteTemplateFun = async (email, client_id, contact_owner) => {
    const req = { id: Number(QuoteId), agent_id: agent_id };
    await dispatch(getQuoteTemplate(req))
      .unwrap()
      .then(async (res) => {
        if (res.status) {
          // console.log("res -- getQuoteTemplate ", res);
          setAllquotetemplate(res.data);
          if (res.data.length > 0) {
            setSelectedTemplate({
              ...selectedTemplate,
              mail_to: email,
              template_id: res.data[0].id,
              subject: res.data[0].subject,
            });
            //await getTemplateContentFun(res.data[0].id,client_id,contact_owner);
            setTemplatestatus(true)
            setIsLoading(false);

          } else {
            setSelectedTemplate({
              ...selectedTemplate,
              mail_to: email,
              template_id: "",
              subject: "",
            });

            await Swal.fire({
              icon: "warning",
              title: "Warning",
              text: "Please create the quote template first",
              timer: 30000,
              timerProgressBar: true,
            });
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
          setAllquotetemplate([]);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  const selectValueOnChange = async (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "email_template_id") {
      const selectedTemplate = allemailtemplate.find(
        (template) => Number(template.id) === Number(value)
      );
      setFormData({
        ...formData,
        email_template_id: value,
        body: selectedTemplate ? selectedTemplate.body : "",
      });
      validate(name, value);
      return;
    }


    validate(name, value);
    setSelectedTemplate({
      ...selectedTemplate,
      [name]: value,
    });
    if (name === "template_id") {
      //  await getTemplateContentFun(value, clientid, quoteData.contact_owner);
    }
  };

  const getTemplateContentFun = async (id, client_id, contact_owner) => {
    const req = {
      id: id,
      clientid: client_id,
      agent_id: agent_id,
      ContractOwner: contact_owner,
      quote_id: QuoteId,
    };

    setIsLoading(true);

    await dispatch(getTemplateContent(req))
      .unwrap()
      .then(async (res) => {
        if (res.status) {
          setTemplatePreviewContent(res.content);
          allquotetemplate &&
            allquotetemplate?.find((val) => {
              if (Number(val.id) === Number(id)) {
                setSelectedTemplate({
                  ...selectedTemplate,
                  template_id: id,
                  subject: val.subject,
                });
              }
            });

          setIsLoading(false);
        } else {
          setTemplatePreviewContent("");
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  const validate = async (name, value) => {
    const newErrors = { ...error };
    if (!value?.trim()) {
      if (name === "mail_to") newErrors[name] = EMPTY_EMAIL_ERROR;
      else if (name === "subject") newErrors[name] = EMPTY_SUBJECT_ERROR;
      else if (name === "template_id") newErrors[name] = EMPTY_SELECT_TEMPLET_ERROR;
      else if (name === "cc_to" || name === "bcc_to") {
        delete newErrors[name]; // clear any previous error
      }
      else if (name === "body") {
        newErrors[name] = EMPTY_TEMPLET_BODY_ERROR;
      }


    }
    // else if (name === "mail_to" && !/^[a-zA-Z0-9._%+-]+@(gmail|yahoo|outbooks|outbook|nomi|rediffmail|hotmail|outlook|aol|icloud|protonmail|example)\.(com|co\.in|in|net|org|edu|gov|uk|us|info|biz|io|...)[a-zA-Z]{0,}$/.test(value)) {
    //   newErrors[name] = INVALID_EMAIL_ERROR;
    // }

    else if (name === "mail_to") {
      let valid = await ValidateEmail(value)
      if (!valid) {
        newErrors[name] = INVALID_EMAIL_ERROR;
      } else {
        delete newErrors[name];
      }
    }



    // else if (name === "cc_to") {
    //   let valid = await ValidateEmail(value)
    //   if (!valid) {
    //     newErrors[name] = INVALID_CC_EMAIL_ERROR;
    //   } else {
    //     delete newErrors[name];
    //   }
    // }


    // else if (name === "bcc_to") {
    //   let valid = await ValidateEmail(value)
    //   if (!valid) {
    //     newErrors[name] = INVALID_BCC_EMAIL_ERROR;
    //   } else {
    //     delete newErrors[name];
    //   }
    // }



    else {
      delete newErrors[name];
    }
    setError(newErrors);
    return Object.keys(newErrors).length === 0 ? true : false;
  };

  let sendAttached = false
  const selectedAttachmentsStore = (data) => {
    sendAttached = true
    setSelectedAttachments(data)
    setShowAttachmentModal(false)

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to add this attachment?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleSubmit()
        // alert("Attachment added successfully!");
        // setShowAttachmentModal(true)
      }
      else {
        await handleSubmit('ignore')
        // alert("Attachment not added!");

      }
    })
  }

  const handleSubmit = async (type) => {

    let valid = true;
    if (!selectedTemplate.mail_to) {
      error.mail_to = EMPTY_EMAIL_ERROR;
      valid = false;
    }
    if (!selectedTemplate.subject) {
      error.subject = EMPTY_SUBJECT_ERROR;
      valid = false;
    }
    if (!selectedTemplate.template_id) {
      error.template_id = EMPTY_SELECT_TEMPLET_ERROR;
      valid = false;
    }

    setError({ ...error });
    if (valid) {


      if (formData.attachments && formData.attachments.length > 0 && selectedAttachments.length == 0  && sendAttached == false) {
        setShowAttachmentModal(true)
        return
        // let reqAttached = { agent_id, agent_id, id: Number(QuoteId), formData: formData, type: 'quote' };
        // await upload_contract_attachment(reqAttached)
      }



      if (selectedAttachments.length > 0 && type != 'ignore') {
        let reqAttached = {
          agent_id,
          id: Number(QuoteId),
          formData: {
            ...formData,
            attachments: selectedAttachments,
          },
          type: "quote",
        };

        await upload_contract_attachment(reqAttached);
      }


      setDisableSubmit(true);
      setIsLoading(true);
      // agent_id, ContractOwner, record_id, template_id, toEmail, subject
      const req = {
        id: Number(QuoteId),
        step: 4,
        mail_to: selectedTemplate.mail_to,
        subject: selectedTemplate.subject,
        template_id: selectedTemplate.template_id,
        clientid: clientid,
        ContractOwner: userDetails.id,
        agent_id: agent_id,
        cc_to: selectedTemplate.cc_to || "",
        bcc_to: selectedTemplate.bcc_to || "",
        email_template_details: formData,
        backupQuoteId: backupQuoteId
      };

      await dispatch(createQuote(req))
        .unwrap()
        .then((res) => {

          if (res.status == true) {
            // console.log("res createQuote", res);
            setIsLoading(false);
            sessionStorage.clear();
            return navigate("/admin/quote/quotes-dashboard");

            // Swal.fire({
            //   icon: "success",
            //   title: "Success",
            //   text: res.message,
            //   timer: 3000,
            //   timerProgressBar: true,
            // }).then(() => {
            //   sessionStorage.clear();
            //   navigate("/admin/quote/quotes-dashboard");
            // });
          } else {
            setDisableSubmit(false);


            Swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((err) => {
          setDisableSubmit(false);
          setIsLoading(false);

          console.log("err", err);
        });
      // nextStep()
    }
  };


  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);

  const viewPdfFunction = async (template) => {

    if (templatestatus === false) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please create the quote template first",
        timer: 20000,
        timerProgressBar: true,
      });
      return
    }



    //     const missingChageBasisChargeType = existingChargeBasis?.filter(
    //   item =>
    //     item.chargetype_rule_id === null &&
    //     item.inputValue === null &&
    //     item.individual_id === null
    // );
    // if (missingChageBasisChargeType.length > 0) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Warning",
    //     text: "The default charge basis used in this quote has been removed. Please create a new one or go back and change the value.",
    //     timer: 20000,
    //     timerProgressBar: true,
    //   });
    //   return;
    // }



    const TemaplateName =
      allquotetemplate?.find((val) => Number(val.id) === Number(template.template_id))?.name ||
      "Quote Template";

    setIsLoading(true);
    const req = {
      id: Number(QuoteId),
      step: 4,
      mail_to: selectedTemplate.mail_to,
      subject: selectedTemplate.subject,
      template_id: selectedTemplate.template_id,
      clientid: clientid,
      ContractOwner: userDetails.id,
      agent_id: agent_id,
      cc_to: selectedTemplate.cc_to || "",
      bcc_to: selectedTemplate.bcc_to || "",
      email_template_details: formData,
      view_pdf: true,
      backupQuoteId: backupQuoteId
    };

    await dispatch(createQuote(req))
      .then(async (res) => {
        if (res?.payload?.status) {
          const base64String = res?.payload?.data;

          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);

          // ✅ Set PDF URL and open modal
          setPdfUrl(blobUrl);
          setShowPdfModal(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res?.payload?.msg,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        console.log("Error", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  const handleAttachmentChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData({
      ...formData,
      attachments: [...formData.attachments, ...files],
    });
  };

  const handleRemoveAttachment = (index) => {
    const updatedAttachments = formData.attachments.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, attachments: updatedAttachments });
  };


  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: '',
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: 'transparent',
        backdrop: 'rgba(229, 233, 236, 0.2)',
        customClass: {
          popup: 'no-shadow',
        }
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>

      <div>
        <div className="row mb-4">
          <div className="col">
            <h4 className="page-title">
              <i className="bx bx-arrow-back text-pink pe-1" onClick={() => prevStep(false)}></i>
              New Quote{" "}
              <span>
                {" "}

              </span>
            </h4>
          </div>
        </div>

        <div className="card pt-4">
          <div className="card-body">
            <h4 className="card-title mb-4">Send Quote</h4>
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label for="exampleInputEmail1" className="form-label">
                    Mail To
                  </label>
                  <input
                    type="text"
                    name="mail_to"
                    className="form-control"
                    id="exampleInputEmail1"
                   // disabled={true}
                    onChange={(e) => selectValueOnChange(e)}
                    value={selectedTemplate.mail_to}
                  />
                  {error.mail_to && (
                    <p className="text-danger">{error.mail_to}</p>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label for="exampleInputEmail1" className="form-label">
                    CC
                  </label>
                  <input
                    type="text"
                    name="cc_to"
                    className="form-control"
                    id="exampleInputEmail1"
                    onChange={(e) => selectValueOnChange(e)}
                    value={selectedTemplate.cc_to}
                  />
                  {error.cc_to && (
                    <p className="text-danger">{error.cc_to}</p>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label for="exampleInputEmail1" className="form-label">
                    BCC
                  </label>
                  <input
                    type="text"
                    name="bcc_to"
                    className="form-control"
                    id="exampleInputEmail1"
                    onChange={(e) => selectValueOnChange(e)}
                    value={selectedTemplate.bcc_to}
                  />
                  {error.bcc_to && (
                    <p className="text-danger">{error.bcc_to}</p>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label for="exampleInputEmail1" className="form-label">
                    Select Email Template
                  </label>
                  <select
                    className="form-select"
                    name="email_template_id"
                    onChange={(e) => selectValueOnChange(e)}
                  >
                    {allemailtemplate && allemailtemplate?.map((val, index) => (
                      <option
                        key={index}
                        value={val.id}
                        selected={val.id === formData.email_template_id}
                      >
                        {val.name}
                      </option>
                    ))}
                  </select>
                  {/* {error.template_id && (
                      <p className="text-danger">{error.template_id}</p>
                    )} */}
                </div>
              </div>

              <div className="col-md-12">
                <div className="row">

                  <label for="exampleInputEmail1" className="form-label">
                    Body
                  </label>
                  <div className="col-sm-12">
                    <JoditEditor
                      ref={editor}
                      config={config1}
                      tabIndex={1}
                      onBlur={(value) => {
                        setContent(value);
                       setFormData({ ...formData, body: value });
                        validate("body", value);
                      }}
                      name="body"
                      // onChange={(value) => {
                      //   setFormData({ ...formData, body: value });
                      //   validate("body", value);
                      // }}
                      value={formData.body || ""}
                    />
                    {error.body && <div className="error-text">{error.body}</div>}

                  </div>
                </div>
              </div>

              <div className="col-md-12 mt-3">
                <div className="mb-3">
                  <label for="exampleInputEmail1" className="form-label">
                    Subject
                  </label>
                  <input
                    type="text"
                    name="subject"
                    className="form-control"
                    id="exampleInputEmail1"
                    onChange={(e) => selectValueOnChange(e)}
                    value={selectedTemplate.subject}
                  />
                </div>
                {error.subject && (
                  <p className="text-danger">{error.subject}</p>
                )}
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label for="exampleInputEmail1" className="form-label">
                    Select PDF Template
                  </label>
                  <select
                    className="form-select"
                    name="template_id"
                    onChange={(e) => selectValueOnChange(e)}
                  >
                    {allquotetemplate?.map((val, index) => (
                      <option
                        key={index}
                        value={val.id}
                        selected={val.id === selectedTemplate.template_id}
                      >
                        {val.name}
                      </option>
                    ))}
                  </select>
                  {error.template_id && (
                    <p className="text-danger">{error.template_id}</p>
                  )}

                  {/* <a
                    href="#"
                    className="mt-2 d-block text-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      handleOpenModal(selectedTemplate.template_id);
                    }}
                  >
                    Preview Template
                  </a> */}

                  <a
                    href="#"
                    className="mt-2 d-block text-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      viewPdfFunction(selectedTemplate);
                    }}
                  >
                    Preview Pdf
                  </a>


                  {showPdfModal && (
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                      <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">PDF Preview</h5>

                            {/* Open in New Tab Button */}
                            <a
                              href={pdfUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-pink btn-sm  ms-2"
                              style={{ fontSize: '10px' }}
                            >
                              Open in New Tab
                            </a>

                            {/* Close Button */}
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setShowPdfModal(false)}
                            ></button>
                          </div>

                          <div className="modal-body">
                            <iframe
                              src={pdfUrl}
                              title="PDF Preview"
                              width="100%"
                              height="600px"
                              style={{ border: "none" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                  )}

                </div>
              </div>


              <div className="col-sm-9">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => document.getElementById("fileInput").click()}
                >
                  <i className="bi bi-paperclip me-2"></i>
                  Add Attachment
                </button>
                <input
                  id="fileInput"
                  type="file"
                  multiple
                  accept=".pdf,.doc,.docx"
                  onChange={handleAttachmentChange}
                  className="d-none"
                />
                <div className="attachment-list mt-3">
                  {formData?.attachments?.map((file, index) => (
                    <div
                      key={index}
                      className="attachment-item d-flex align-items-center justify-content-between mb-2 p-2"
                    >
                      <div className="d-flex align-items-center gap-2">
                        <div className="file-icon">
                          <i className="bi bi-paperclip"></i>
                        </div>

                        <span className="file-name">{file?.name}</span>
                      </div>

                      <button
                        type="button"
                        className="btn btn-sm btn-light-danger remove-btn"
                        onClick={() => handleRemoveAttachment(index)}
                      >
                        <i className="bi bi-x-lg"></i>
                      </button>
                    </div>
                  ))}
                </div>

              </div>

            </div>

            <div className="d-flex justify-content-between mt-3">
              {currentStep > 1 && (
                <button
                  className="btn btn-secondary"
                  onClick={() => prevStep(false)}
                  disabled={prevButtonStatus}
                >
                  Previous
                </button>
              )}
              <button
                disabled={disableSubmit}
                className="btn btn-pink"
                onClick={handleSubmit}
              >
                {currentStep < 4 ? "Next" : "Send"}
              </button>
            </div>
          </div>
        </div>

        {/* Modal for Preview */}
        {isModalOpen && (
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Template Preview</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal}
                  ></button>
                </div>
                {/* <div className="modal-body">
                <p>{cleanHtmlContent(templatePreviewContent)}</p>
              </div> */}
                <div
                  className="modal-body preview-body"
                  dangerouslySetInnerHTML={{
                    __html: templatePreviewContent || "",
                  }}
                  readOnly
                />
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <ReusableModal
          class="systemsettimg-modal"
          show={isModalPackageEffected}
          modalContentClass="systemsetting-modal"
          showCloseButton={false}
          title={
            <>
              The selected service/package has been updated or deleted. Your existing quote is currently In Progress.
              <br />
              <br />

              Please choose how you want to proceed.
            </>
          }
          footer={
            <div className="justify-content-center d-flex w-100">
              <button
                type="button"
                className="btn btn-outline-pink rounded w-auto me-3"
                style={{
                  fontSize: "12px",
                  height: "53px"
                }}
                onClick={() => prevStep(false)}
              >
                Create Quote With Updated Pricing
              </button>
              <button
                type="button"
                className="btn btn-pink rounded w-auto"
                style={{
                  fontSize: "12px",
                  height: "53px"
                }}
                onClick={() => setIsModalPackageEffected(false)}
              >
                Proceed With Existing Quote
              </button>


            </div>
          }
        />


        <ReusableModal
          show={showAttachmentModal}
           onClose={() => {setShowAttachmentModal(false) ;setSelectedAttachments([])}}
          modalsize="lg"
          title={
            <span className="text-pink fw-bold" style={{ fontWeight: "600", fontSize: "20px" }}>Select Attachments</span>
          }
          body={
            <>

              {formData?.attachments?.map((file, index) => (
                <div key={index}>
                  <input
                    type="checkbox"
                    checked={selectedAttachments.some(
                      (f) => f.name === file.name && f.lastModified === file.lastModified
                    )}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedAttachments([...selectedAttachments, file]);
                      } else {
                        setSelectedAttachments(
                          selectedAttachments.filter(
                            (f) =>
                              !(
                                f.name === file.name &&
                                f.lastModified === file.lastModified
                              )
                          )
                        );
                      }
                    }}
                  />
                  <label style={{ marginLeft: "8px" }}>
                    {file.name}
                  </label>
                </div>
              ))}



            </>
          }
          footer={
            <>
              <button className="btn btn-pink"
                onClick={() => {
                  setFormData({
                    ...formData,
                    attachments: selectedAttachments,
                  });
                  setShowAttachmentModal(false);
                  selectedAttachmentsStore(selectedAttachments);
                }}>
                Done
              </button>
              <button
                className="btn btn-outline-secondary"
                onClick={() => {setShowAttachmentModal(false) ; setSelectedAttachments([])}}>
                Cancel
              </button>

            </>
          }
        />






      </div>

    </>
  );
};

export default StepThree;
